import { call, put } from 'redux-saga/effects';
// COMMON
import { notification } from 'elements';
import * as actionTypes from '@/redux/new_store_structure/actions/actionsTypes';
import { wsClient } from '@/index';

export function* getSitesListSaga(action) {
	/**
	 * @param clientId
	 */
	yield put({
		type: actionTypes.SITES_START,
	});
	const { params } = action.payload;
	const requestPayload = {
		messageType: 'core.site.list-sites',
		payload: {
			...params,
		},
	};

	try {
		const { payload } = yield wsClient.request(requestPayload);
		yield put({
			type: actionTypes.SITES_LIST_SUCCESS,
			payload,
		});
	} catch (error) {
		console.log('ERR', error);
		yield put({
			type: actionTypes.SITES_FAILED,
			payload: { error },
		});
		yield call(notification.error, {
			message: 'Error',
			description: error.message,
			placement: 'bottomLeft',
		});
	}
}
export function* getSitesZonesListSaga(action) {
	/**
	 * @param clientId
	 */
	yield put({
		type: actionTypes.SITES_START,
	});
	const { params } = action.payload;
	const requestPayload = {
		messageType: 'core.site.list-zones',
		payload: {
			...params,
		},
	};

	try {
		const { payload } = yield wsClient.request(requestPayload);
		yield put({
			type: actionTypes.SITES_ZONES_LIST_SUCCESS,
			payload,
		});
	} catch (error) {
		console.log('ERR', error);
		yield put({
			type: actionTypes.SITES_FAILED,
			payload: { error },
		});
		yield call(notification.error, {
			message: 'Error',
			description: error.message,
			placement: 'bottomLeft',
		});
	}
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/sagas/sites.js